import { ChatAppointmentFragment$data } from "@/modules/chats/services/fragments/__generated__/ChatAppointmentFragment.graphql"
import { ChatThread } from "@/modules/chats/types/chat-thread"

export type ChatAppointment = Omit<ChatAppointmentFragment$data, " $fragmentType">

export const getChatThreadByChatAppointment = (chatAppointment: ChatAppointment): ChatThread => {
  const threadId = chatAppointment.chat?.threadId ?? ""
  const autoTranslationSetting = chatAppointment.chat?.autoTranslationSetting

  return {
    id: threadId,
    appointmentId: chatAppointment.id,
    appointmentService: chatAppointment.service,
    language: chatAppointment.language,
    isMedicalChat: chatAppointment.service === "CONSULTATION",
    patient: chatAppointment.patient,
    questionnaireId: chatAppointment.questionnaireId,
    greetingMessageReceived: chatAppointment.chat?.greeting?.received ?? false,
    autoTranslationSetting: autoTranslationSetting
      ? {
          isLiveTranslationEnabled: autoTranslationSetting.isLiveTranslationEnabled,
          targetAgentLanguage: autoTranslationSetting.targetAgentLanguage,
        }
      : null,
  }
}
